export default __webpack_public_path__ + "static/media/mobileanalytics.9e8bd79c.svg";